import OrganizationUnavailable from "@/components/OrganizationUnavailable";
import { useAuth } from "@/context/auth.context";
import { useOrganization } from "@/context/organization.context";
import { app_env, env_config } from "@/env-config";
import useDomain from "@/hooks/use-domain";
import { Navigate, Outlet, useLocation } from "react-router-dom";
export default function RootLayout() {
  const { user, loading } = useAuth();
  const { isLoading: isLoadingOrg, activeOrg, orgStatus } = useOrganization();

  const location = useLocation();

  const { orgDomain } = useDomain(env_config[app_env].domain);

  if (orgDomain && !activeOrg && !isLoadingOrg) {
    return (
      <OrganizationUnavailable
        reason={orgStatus?.reason ?? "not-found"}
        domain={orgStatus?.domain ?? orgDomain}
        organizationName={orgStatus?.organizationName}
        lastActivityAt={orgStatus?.lastActivityAt}
      />
    );
  }

  if (
    (loading || isLoadingOrg) &&
    location.pathname !== "/" &&
    location.pathname !== "/auth/choose-module"
  ) {
    return (
      <div className=" w-screen h-dvh bg-card flex items-center justify-center flex-col gap-8">
        <div className="flex items-center justify-center flex-col gap-6">
          <div className="w-full- m-auto- flex flex-col gap-6 justify-center items-center">
            <img className="h-9" src={env_config[app_env].logo} alt="" />
            {app_env === "table-tronic" ? (
              <div className="tb-loader" />
            ) : (
              <div className="loader" />
            )}
          </div>
        </div>
      </div>
    );
  }

  if (!user && !loading) {
    if (
      location.pathname === "/login" ||
      location.pathname === "/auth/choose-module" ||
      location.pathname === "/auth/" ||
      location.pathname === "/forgot-password" ||
      location.pathname === "/reset-password" ||
      // "/" is the TableTronic home, or a redirect to /login for OneSuite
      // (the public website is its own app, in website/).
      location.pathname === "/"
    )
      return <Outlet />;
    return <Navigate to={`/login?redirect=${location.pathname}`} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
}
